import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  saveCoverageSelection,
  selectCoverageSelection,
} from 'redux/features/plans/plansSlice';
import { coverageTypes, planPaymentMode } from 'common/utils/enums';

export const useDefaultCoverageSelection = ({
  isLeaveAnytimeEligible=true,
  isCancelAnytimeEligible=false,
}) => {
  const dispatch = useDispatch();
  const coverageSelection = useSelector(selectCoverageSelection);

  useEffect(() => {
    if (!coverageSelection?.[coverageTypes.LEAVE_ANYTIME] && isLeaveAnytimeEligible) {
      dispatch(
        saveCoverageSelection({
          ...coverageSelection,
          [coverageTypes.LEAVE_ANYTIME]: planPaymentMode.SUBSCRIPTION,          
        })
      );
    }

    if (!coverageSelection?.[coverageTypes.CANCEL_ANYTIME] && isCancelAnytimeEligible) {
      dispatch(
        saveCoverageSelection({
          ...coverageSelection,
          [coverageTypes.CANCEL_ANYTIME]: planPaymentMode.ONE_TIME,
        })
      );
    }
  }, [coverageSelection, dispatch]);
};